/* eslint no-console:0 */

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";

Rails.start();
Turbolinks.start();

const images = require.context('../images', true)

import "../src/application.scss";

import {setupExcerptsForm, setupContentFileUppy, setupImageUppy} from "./publications.js";
import {copyTextToClipboard, handleQrCodes} from "./excerpts.js";
import {setupTlcForms} from "./tlc.js";
import {updateRangeValueDisplay} from "./my-settings";

document.addEventListener('turbolinks:load', () => {
    handleQrCodes();
    setupExcerptsForm();
    handleActivateButtons();
    handleCopyButtons();
    updateRangeValueDisplay();
    setupTlcForms();

    document.querySelectorAll('[data-uppy]').forEach(element => {
        if (element.hasAttribute('data-image-select')) {
            setupImageUppy(element);
        } else if (element.hasAttribute(    'data-epub-select')) {
            setupContentFileUppy(element);
        }
    })
});

function handleCopyButtons() {
    $('.button.copy-to-clipboard').on('click', function(e) {
        let $button = $(this);
        let v = $button.data('clipboardText');

        copyTextToClipboard(v).then(function() {
            $button.html("Copied");
            setTimeout(() => { $button.html("Copy") }, 4000);
        }, function() {
            $button.html("Couldn't copy :(");
            setTimeout(() => { $button.html("Copy") }, 4000);
        });
    });
}

function handleActivateButtons() {
    $('.button.activate-client-excerpt').on('click', function(e) {
        let $button = $(this);
        const excerptUrl = $button.data('excerptUrl');

        fetch(excerptUrl)
            .then(function() {
                $button.html("Activated");
                let current_url = window.location.href.replace(/#.*$/, "");
                const redirect_url = current_url + '#client-urls';
                location.href = redirect_url;
                location.reload();
            })
            .catch(function(){
                $button.html("Failed");
            });
    });
}


/* helpers for association add/remove buttons */
$(document).on('turbolinks:load', function() {
    $('form').on('click', '.add_fields', function(event) {
        const $associationContainer = $(this).prev();

        let regexp, time;
        time = new Date().getTime();
        regexp = new RegExp($(this).data('id'), 'g');
        $associationContainer.append($(this).data('fields').replace(regexp, time));
        return event.preventDefault();
    });
});
